export default __webpack_public_path__ + "static/char-s-01-chs-fdcb946b242746e7794c265ee3ce2259.webp";